import { Stack, styled } from '@mui/material';

export const Root = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  border: `0.5px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(1),
  color: theme.palette.common.black,
  overflow: 'hidden',
}));
